import { render, staticRenderFns } from "./petition-info.vue?vue&type=template&id=6548db13&scoped=true&"
import script from "./petition-info.vue?vue&type=script&lang=js&"
export * from "./petition-info.vue?vue&type=script&lang=js&"
import style0 from "./petition-info.vue?vue&type=style&index=0&id=6548db13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6548db13",
  null
  
)

export default component.exports